"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--smar--ursa-icons--meterFillColor, #ADC6FA)",
  d: "M12 7.35a9.3 9.3 0 0 0-9.3 9.3h4.87c0-2.347 1.903-4.275 4.25-4.275s4.25 1.928 4.25 4.275h5.23a9.3 9.3 0 0 0-9.3-9.3Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.428 15.95H6.92a4.99 4.99 0 0 1 1.715-3.104L6.72 9.861a8.588 8.588 0 0 0-3.292 6.089Zm4.463-6.857L9.82 12.1a4.894 4.894 0 0 1 2.001-.425c.821 0 1.595.202 2.276.558l2.013-3.14A8.562 8.562 0 0 0 12 8.05a8.562 8.562 0 0 0-4.109 1.043Zm9.389.768-2.046 3.191c.208.2.399.418.57.65l1.36-.742a.7.7 0 1 1 .671 1.23l-1.369.746c.12.324.205.663.255 1.014h3.85a8.588 8.588 0 0 0-3.291-6.09Zm-2.062 5.756c.099.327.152.674.152 1.033a.7.7 0 0 0 .7.7h5.23a.7.7 0 0 0 .7-.7c0-5.523-4.477-10-10-10s-10 4.477-10 10a.7.7 0 0 0 .7.7h4.87a.7.7 0 0 0 .7-.7c0-1.966 1.595-3.575 3.55-3.575 1.1 0 2.087.51 2.74 1.307l-2.895 1.578a.7.7 0 1 0 .67 1.23l2.883-1.573Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=MeterThreeIcon24.js.map